<template>
    <div class="vitamin-container">
        <div v-src="'https://oss.cloud.custouch.com/res/21370/第2层-维生素学院banner.jpg'"
             class="default-banner-wrapper">
            <span>维生素学苑<em>-维妙维效</em> </span>
            <span class="tip">缤纷科技，美好生活<sup>TM</sup></span>
        </div>
        <div class="section-wrapper">
            <router-link class="section-wrapper-item"
                         v-for="item in sections"
                         :key='item.name'
                         :to="{name:item.route}">
                <img v-src="item.img">
                <span>{{item.name}}</span>
            </router-link>
        </div>
        <div class="hot-list">
            <div class="title-wrapper">
                <h4>热门推荐</h4>
            </div>
            <div class="list-wrapper">
        
                <List-View :list='list' row-key="title">
                    <template #button="{item}">
                        <div class="default-button"
                             @click='viewCourse({id:item.webinarId,name:item.title})'
                             v-if='item.webinarId'>
                            <img src="@/assets/imgs/课程预约.png">
                            课程预约
                        </div>
                        <div class="default-button"
                             @click='viewCourse({id:item.videoId,name:item.title})'
                             v-else> <img src="@/assets/imgs/在线观看.png">在线观看</div>
                    </template>
                </List-View>
            </div>
        </div>
    </div>
</template>
<script>
import ListView from './compoennts/ListView'
import checkCourse from './checkCourse'
import fetchData from '@/service/fetchData'

export default {
    mixins: [checkCourse],
    components: {
        ListView
    },
    data() {
        return {
            sections: [
                {
                    "img": "https://oss.cloud.custouch.com/res/27505/02.png",
                    "name": "维生素学苑",
                    route: "SchoolIntro"
                },
                {
                    "img": "https://oss.cloud.custouch.com/res/27503/03.png",
                    "name": "维生素主题月",
                    route: "vitaminTheme"

                },
                {
                    "img": "https://oss.cloud.custouch.com/res/28246/帝斯曼-4-9-切图首页-讲师风采.png",
                    "name": "讲师风采",
                    route: "VCLecturer"
                },
                {
                    "img": "https://oss.cloud.custouch.com/res/27495/05.png",
                    "name": "个人中心",
                    route: "ApponitedCourse"
                }
            ],
            list: []
        }
    },
    methods: {
        async init() {
            const { VUE_APP_VC_RECOMMEND_COURSE } = window.env
            this.list = await fetchData(VUE_APP_VC_RECOMMEND_COURSE)
        }
    },
    created() {
        this.init()
    }
}
</script>
<style scoped lang='less'>
.section-wrapper {
	display: flex;
	justify-content: space-between;
	padding: 1rem 0.5rem;
	border-bottom: 4px solid #f9f9f9;
	&-item {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		img {
			width: 2.8rem;
			margin-bottom: 0.4rem;
		}
	}
}
.hot-list {
	padding: 1.2rem 1rem;
	.title-wrapper {
		display: inline-block;
		background: linear-gradient(90deg, #ee7202, rgba(238, 114, 2, 0) 100%);
		padding-bottom: 1px;
		margin-bottom: 0.8rem;
		h4 {
			display: inline-block;
			font-size: 0.8rem;
			background: #fff;
		}
	}
}
</style>